"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.STATE_PAGE = exports.LEGAL_DEFINITION = exports.LEARN_ARTICLE = exports.LANDING_PAGE = exports.HOME_PAGE = exports.FRESH_START_DIARY = exports.DONATIONS_PAGE = exports.CONSUMER_REPORT = exports.CITY_PAGE = exports.AUTHOR_PROFILE = exports.ATTORNEY_PROFILE = exports.ATTORNEY_DIRECTORY = void 0; // The only 5 Content Groups for Google Analytics. /frontdoor has a consolidation mapping

exports.ATTORNEY_DIRECTORY = "attorneyDirectory";
exports.ATTORNEY_PROFILE = "attorneyProfile";
exports.AUTHOR_PROFILE = "authorProfile";
exports.CITY_PAGE = "cityPage";
exports.CONSUMER_REPORT = "consumerReport";
exports.DONATIONS_PAGE = "donationsPage";
exports.FRESH_START_DIARY = "freshStartDiary";
exports.HOME_PAGE = "homePage";
exports.LANDING_PAGE = "landingPage";
exports.LEARN_ARTICLE = "learnArticle";
exports.LEGAL_DEFINITION = "legalDefinition";
exports.STATE_PAGE = "statePage";